import $ from 'jquery';
import lockScroll from './lockScroll';
import getLayout from './get-modal-layout';
import Modal from './modal';
import {PageName} from './constants';
import TweenlineMax from 'gsap';

const classNames = {
  header: {
    BUTTON_MENU_HIDDEN: `page-header__menu--hidden`
  },
  modal: {
    NAV_ITEM_MOVED: `modal__navigation-item--moved`
  },
  footer: {
    FOOTER_EXPANDED: `page-footer--expanded`
  }
};

const screens = [...document.querySelectorAll(`.screen.section`)];

class ModalNavigation extends Modal {
  constructor() {
    super();
    this.pageType = ``;
    this.footer = this.page.querySelector(`.page-footer`);
    this.isMobile = false;
    this.menuButton = this.page.querySelector(`.page-header__menu`);
    this.links = [];
  }

  createModal() {
    const wrapper = document.createElement(`div`);
    const content = document.createElement(`div`);
    const close = document.createElement(`div`);

    wrapper.className = `${this.classNames.MODAL} ${this.classNames.MODAL_SHOWN} ${this.classNames.MODAL_NAVIGATION}`;
    content.className = this.classNames.MODAL_CONTENT;
    close.className = this.classNames.MODAL_CLOSE;

    this.wrapper = wrapper;
    this.content = content;
    this.close = close;

    this.page.appendChild(wrapper);
    wrapper.appendChild(content);
    wrapper.appendChild(close);

    // this.bind();
  };

  init(isMobile, pageType, locale) {
    this.isMobile = isMobile;
    this.pageType = pageType;

    this.createModal();

    this.createNavigation(locale);
    this.bindHandlers();
  }

  createNavigation(locale) {
    const path = this.pageType === `main` ? `#` : `/#`;
    const navigationLayout = getLayout(`navigation`, path, locale);

    super.addLayout(navigationLayout);
    this.links = [...this.page.querySelectorAll(`.modal__navigation-item`)];
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
    const animationStartValue = isModalShown ? 0 : '100vh';
    const animationFinishValue = isModalShown ? '100vh' : 0;
    const animationStartLinks = isModalShown ? 0 : 1;
    const animationFinishLinks = isModalShown ? 1 : 0;

    var tl = new TimelineMax();
    if (isModalShown) {
      tl
        .fromTo('.modal.modal--navigation', .7, { height: animationStartValue }, { height: animationFinishValue, zIndex: 11 })
        .staggerFromTo('.modal__navigation-item', .3, { ease: Expo.easeInOut, opacity: animationStartLinks }, { ease: Expo.easeInOut, opacity: animationFinishLinks }, .07, '+=.2')
    } else {
      tl
        .staggerFromTo($('.modal__navigation-item').get().reverse(), .3, { ease: Expo.easeInOut, opacity: animationStartLinks }, { ease: Expo.easeInOut, opacity: animationFinishLinks }, .07)
        .fromTo('.modal.modal--navigation', .7, { height: animationStartValue }, { height: animationFinishValue, zIndex: 11 }, '-=.5')
    }

    if (this.pageType === PageName.MAIN) {
      this.footer.classList.toggle(classNames.footer.FOOTER_EXPANDED, isModalShown);
    }
    lockScroll(true);
  };

  bindHandlers() {
    this.close.addEventListener(`click`, () => {
      this.toggleModal(false);
      lockScroll(false);
    });

    this.menuButton.addEventListener(`click`, () => {
      this.toggleModal(true);
      if (this.isMobile) {
        $('.mobile-phone.js-phone').addClass('mobile-phone--hidden');
      }

      if (!this.isMobile) {
        this.links.forEach(link => link.classList.add(classNames.modal.NAV_ITEM_MOVED));
      } else {

      }
    });

    this.links.forEach(link => link.addEventListener(`click`, () => {
      if (this.isMobile) {
        lockScroll(true);
        this.onClose();
      } else {
        this.resetLinksState();
      }
      this.toggleModal(false);
    }));
  }

  resetLinksState = () => {
    setTimeout(() => {
      this.links.forEach(link => link.classList.remove(classNames.modal.NAV_ITEM_MOVED));
    }, 300);
  };

  onClose() {
    this.resetLinksState();
  }
}

const modalNavigation = new ModalNavigation();

export default modalNavigation;
